import { Button, SxProps } from '@mui/material'
import React from 'react'
import { Link } from 'react-router-dom'

interface ButtonProps {
  text: string | JSX.Element
  icon?: JSX.Element
  isIconRight?: boolean
  onClick?: () => void
  sx?: SxProps
  iconSx?: SxProps
  href?: string
  external?: boolean
  disabled?: boolean
}

const PureResourcesDetailsButton: React.FC<ButtonProps> = ({
  text,
  icon,
  isIconRight,
  onClick,
  sx,
  iconSx,
  href,
  disabled
}: ButtonProps) => {
  const _icon = icon
    ? React.cloneElement(icon, { sx: { width: '20px', height: '20px', ...iconSx } })
    : null

  return (
    <Button
      variant='contained'
      disabled={disabled}
      sx={{
        padding: '8px 16px',
        display: 'flex',
        alignItems: 'center',
        gap: '6px',
        fontSize: 14,
        lineHeight: '19px',
        color: '#ffffff',
        ...sx
      }}
      onClick={onClick}
    >
      {isIconRight ? <>{text}{_icon}</> : <>{_icon}{text}</>}
    </Button>
  )
}

const ResourcesDetailsButton: React.FC<ButtonProps> = ({
  text,
  icon,
  isIconRight,
  onClick,
  sx,
  iconSx,
  href,
  external,
  disabled
}) => {
  if (!href) {
    return (
      <PureResourcesDetailsButton
        text={text}
        icon={icon}
        isIconRight={isIconRight}
        onClick={onClick}
        sx={sx}
        iconSx={iconSx}
        disabled={disabled}
      />
    )
  }

  if (external) {
    return (
      <a href={href} target='_blank' rel='noreferrer'>
        <PureResourcesDetailsButton
          text={text}
          icon={icon}
          isIconRight={isIconRight}
          onClick={onClick}
          sx={sx}
          iconSx={iconSx}
          disabled={disabled}
        />
      </a>
    )
  }

  return (
    <Link to={href}>
      <PureResourcesDetailsButton
        text={text}
        icon={icon}
        onClick={onClick}
        sx={sx}
        iconSx={iconSx}
        disabled={disabled}
      />
    </Link>
  )
}

const ResourcesDetailsLightButton: React.FC<ButtonProps> = ({
  text,
  icon,
  onClick,
  sx,
  iconSx,
  href,
  disabled
}: ButtonProps) => {
  return (
    <ResourcesDetailsButton
      text={text}
      icon={icon}
      onClick={onClick}
      sx={{
        backgroundColor: 'white',
        '&:hover': {
          backgroundColor: 'white'
        },
        border: '1px solid #17374F',
        color: '#17374F',
        ...sx
      }}
      disabled={disabled}
      iconSx={iconSx}
      href={href}
    />
  )
}

export {
  ResourcesDetailsButton,
  ResourcesDetailsLightButton
}

